var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 19,
    stroke: "#333333",
    strokeOpacity: 0.1,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6027 20.736L24.5752 27.6525C24.4219 27.8042 24.2149 27.8893 23.9992 27.8893C23.7835 27.8893 23.5765 27.8042 23.4232 27.6525L16.3957 20.7375C16.2414 20.5859 16.0337 20.501 15.8174 20.501C15.6011 20.501 15.3935 20.5859 15.2392 20.7375C15.1632 20.8116 15.1028 20.9001 15.0616 20.9979C15.0204 21.0957 14.9991 21.2007 14.9991 21.3068C14.9991 21.4129 15.0204 21.5179 15.0616 21.6157C15.1028 21.7134 15.1632 21.802 15.2392 21.876L22.2652 28.791C22.728 29.2454 23.3506 29.5 23.9992 29.5C24.6478 29.5 25.2704 29.2454 25.7332 28.791L32.7592 21.876C32.8354 21.8019 32.896 21.7133 32.9373 21.6154C32.9787 21.5175 33 21.4123 33 21.306C33 21.1997 32.9787 21.0945 32.9373 20.9966C32.896 20.8987 32.8354 20.8101 32.7592 20.736C32.6049 20.5844 32.3972 20.4995 32.1809 20.4995C31.9646 20.4995 31.757 20.5844 31.6027 20.736Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDropdownIcon);
export default __webpack_public_path__ + "static/media/FilterDropdownIcon.600d3319e278f8b05752050e603cf672.svg";
export { ForwardRef as ReactComponent };